if ( typeof CountdownClock !== 'function' ) {

  class CountdownClock extends HTMLElement {

    constructor(){
      super();
      this.init();
    }

    init(){

      this.daysEl = this.querySelector('.days');
      this.hoursEl = this.querySelector('.hours');
      this.minutesEl = this.querySelector('.minutes');
      this.secondsEl = this.querySelector('.seconds');

      const date = this.dataset.date.split(',').map(Number);
      const gmt = Number(this.dataset.timezone);
      // HHC CUSTOM: match the fixed GMT offset used by the server-rendered placeholders.
      this.COUNT = Date.UTC(date[0], date[1] - 1, date[2], date[3]) - gmt * 60 * 60 * 1000;

      this._countdownBannerInterval = setInterval(this.#countEachSecond.bind(this), 1000);
      this.#countEachSecond();
      if ( this.classList.contains('hide') ) {
        this.classList.remove('hide');
      }

    }

    #countEachSecond(){

      const remaining = this.COUNT - Date.now();
      const distance = Number.isFinite(remaining) ? Math.max(0, remaining) : 0;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.#updateDigits(this.daysEl, days);
      this.#updateDigits(this.hoursEl, hours);
      this.#updateDigits(this.minutesEl, minutes);
      this.#updateDigits(this.secondsEl, seconds);

      if ( distance === 0 ) {
        clearInterval(this._countdownBannerInterval);
      }
    }

    #updateDigits(element, value){
      const digits = value.toString().padStart(2, '0');
      // Keep unchanged digit nodes in place instead of rebuilding all four fields every second.
      if ( element.textContent === digits ) return;
      if ( element.children.length !== digits.length ) {
        element.innerHTML = digits.split('').map(digit=>`<span>${digit}</span>`).join('');
        return;
      }
      Array.from(element.children).forEach((digit, index)=>{
        if ( digit.textContent !== digits[index] ) digit.textContent = digits[index];
      });
    }

    disconnectedCallback(){
      if ( this._countdownBannerInterval ) {
        clearInterval(this._countdownBannerInterval);
      }
    }

  }

  if ( typeof customElements.get('countdown-clock') == 'undefined' ) {
    customElements.define('countdown-clock', CountdownClock);
  }

}
